import { CustomTextField, useWarrantyClaimContext } from '@components';
import { Grid } from '@mui/material';
import { customerFields } from './warranty.config';

export const WarrantyCustomerFields = () => {
  const { form, isReadOnly } = useWarrantyClaimContext();

  return (
    <Grid container spacing={{ xs: 0, sm: 2 }}>
      <Grid item xs={12} lg={6}>
        {customerFields().map((field) => (
          <CustomTextField
            {...form.register(field.name, { required: field.required })}
            key={field.name}
            name={field.name}
            label={field.label}
            error={!!form.formState.errors[field.name]}
            sx={{ mt: 5 }}
            InputProps={{
              readOnly: isReadOnly,
            }}
            required={field.required && !isReadOnly}
          />
        ))}
      </Grid>
    </Grid>
  );
};
